import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PillarsSection from './components/PillarsSection';
import DifferentialsSection from './components/DifferentialsSection';
import CTASection from './components/CTASection';

const SCHEMA_ORG = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
      name: 'LOPES BUSINESS',
      url: import.meta.env.VITE_SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://public.readdy.ai/ai/img_res/a0dfe006-6179-422d-9045-deb7cf8a960a.png',
      },
      description:
        'Consultoria estratégica esportiva, blindagem patrimonial e operações financeiras internacionais para atletas e empresários de alta performance. Atuando desde 2018.',
      foundingDate: '2018',
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: 'Portuguese',
      },
      areaServed: 'Worldwide',
      knowsAbout: [
        'Consultoria Esportiva',
        'Blindagem Patrimonial',
        'Operações Financeiras Internacionais',
        'Criptomoedas',
        'Family Office',
        'Grandes Eventos',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'LOPES BUSINESS',
      publisher: {
        '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
      },
      inLanguage: 'pt-BR',
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/#webpage`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'LOPES BUSINESS | Consultoria Esportiva e Blindagem Patrimonial Internacional',
      description:
        'LOPES BUSINESS - Consultoria estratégica esportiva, blindagem patrimonial e operações financeiras internacionais para atletas e empresários de alta performance. Atuando desde 2018.',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      inLanguage: 'pt-BR',
    },
  ],
};

const HomePage = () => {
  useEffect(() => {
    const id = 'schema-home';
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(SCHEMA_ORG);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-[#0B0B0D] min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PillarsSection />
        <DifferentialsSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
